export const getBuyShippingPriceField = (value: boolean) => {
    const newPriceField = value ? 'finalPriceWithTax' : 'initialPriceWithoutTax'
    const oldPriceField = !value ? 'finalPriceWithTax' : 'initialPriceWithoutTax'
    return { newPriceField, oldPriceField}
}